import React from "react";
import CurriculumHeader from "components/header/CurriculumHeader";
import Accordion from "components/accordion/Accordion";
import { accordions } from "components/accordion/accordions";

const SubjectsList = () => {
  return (<div className="flex flex-col justify-center gap-10 xl:gap-10 xl:mx-24 mt-10">
    <CurriculumHeader
      title="ԱՌԱՐԿԱՅԱՑԱՆԿ"
      sectionTitle="ԲՈՎԱՆԴԱԿՈՒԹՅՈՒՆ"
      buttonTitle="Դասընթացներ"
      buttonLink="/courses"
    />
    <div class="p-6 xl:p-[48px_100px] justify-between items-center bg-white rounded-[24px]">
      <h3 class="indent-8 text-[#1E1E1E] text-left text-[24px] font-[700] my-8">
        Ազգային կրթակարգի քաղաքակրթական բաղադրիչի ապահովման առարկայացանկ՝
        1-12-րդ դասարանների ուսումնական պլանի հիմքով
      </h3>
      {accordions.map((accordion, index) => (
        <Accordion key={index} item={accordion} />
      ))}
    </div>
  </div>);
};

export default SubjectsList;
